import React from "react";

import CardSkeleton from "../components/CardSkeleton";

import * as S from "./style";

const PageSkeleton = ({ isLoading, children }) => {
  return isLoading ? (
    <S.SkeletonContainer>
      <S.RequestBandWidthSkeletonContainer>
        <S.RequestWrapper>
          <CardSkeleton />
        </S.RequestWrapper>
        <hr className="divider" />
        <S.BandWidthWrapper>
          <CardSkeleton />
        </S.BandWidthWrapper>
      </S.RequestBandWidthSkeletonContainer>
      <CardSkeleton />
    </S.SkeletonContainer>
  ) : (
    children
  );
};

export default PageSkeleton;
